import { isMultiValueSearchField } from 'modules/domains/segmentation/utils/isMultiValueSearchField';
import { convertValuesToOptions } from '../utils/convertValuesToOptions';
import { useConditionState } from '../../../../hooks';

export const useTypeaheadSelectedOptions = () => {
  const [searchField] = useConditionState();
  return isMultiValueSearchField(searchField) ? convertValuesToOptions(searchField.values) : [];
};
